<template>
    <div class="d-flex justify-content-between">
        <div class="py-3 py-md-0">
            <b-card-title>{{ item.name }}</b-card-title>
            <div class="in-path">
                <ul class="list-inline">
                    <li class="list-inline-item">
                        <span
                            :class="[
                                'badge',
                                'badge-pill',
                                'text-capitalize',
                                'badge-collection',
                            ]"
                            >{{ $t("collection") }}</span
                        >
                    </li>
                    <li v-if="clients.length > 1" class="list-inline-item">
                        <strong>{{ $t("client") }}:</strong>
                        {{ item.client.name }}
                    </li>
                    <li class="list-inline-item">
                        <strong>{{ $t("products") }}: </strong>
                        {{ item.products_count }}
                    </li>
                </ul>
            </div>
        </div>
        <b-dropdown
            variant="link"
            right
            toggle-class="text-decoration-none text-secondary three-dots-btn"
            no-caret
        >
            <template v-slot:button-content>
                <font-awesome-icon icon="ellipsis-v"></font-awesome-icon>
            </template>
            <b-dropdown-item @click.stop="selectCollection">{{
                $t("view_collection")
            }}</b-dropdown-item>
            <b-dropdown-item
                @click.stop="showEditDialog = true"
                v-if="$can('edit collection')"
            >
                {{ $t("edit_collection") }}
                <collection-dialog
                    @saved="search"
                    v-model="showEditDialog"
                    :id="item.id"
                ></collection-dialog>
            </b-dropdown-item>
            <b-dropdown-item
                href="#"
                @click.stop="showProductDialog = true"
                v-if="$can('create base product')"
            >
                {{ $t("add_product_here") }}
                <base-product-dialog
                    @saved="search"
                    v-model="showProductDialog"
                    :collection_id="item.id"
                ></base-product-dialog>
            </b-dropdown-item>
            <b-dropdown-item
                @click.stop="confirmDelete(item.name, deleteCollection)"
                v-if="$can('delete collection')"
                >{{ $t("delete") }}</b-dropdown-item
            >
        </b-dropdown>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import CollectionDialog from "./../EditDialogs/CollectionDialog";
import BaseProductDialog from "../EditDialogs/BaseProductDialog";
import axios from "axios";

export default {
  name: "Collection",
  components: { BaseProductDialog, CollectionDialog },
  props: {
    item: Object
  },
  data() {
    return {
      showEditDialog: false,
      showProductDialog: false
    };
  },
  computed: {
    ...mapState({
      clients: state => state.smartVaultSearch.clients
    })
  },
  methods: {
    ...mapActions("smartVaultSearch", ["search"]),
    selectCollection() {
      this.$store.commit("smartVaultSearch/setClientAndCollection", {
        client: this.item.client.id,
        collection: this.item.id
      });
    },
    deleteCollection() {
      axios.delete(`/api/collections/${this.item.id}`).then(() => {
        // In case a collection was selected, we should unselect it...
        this.$store.commit("smartVaultSearch/setCollection", null);
        // Show confirmation of deletion
        this.$bvToast.toast(
          this.$t("item_deleted_confirmation", {
            item: this.item.name
          }),
          {
            title: this.$t("item_deleted"),
            toaster: "b-toaster-top-right",
            autoHideDelay: 5000,
            appendToast: true,
            solid: true,
            variant: "success"
          }
        );
        // Refresh list
        this.search();
      });
    }
  }
};
</script>

<style scoped>
</style>
